import React from "react"
import Header from "./components/Header"
import Form from "./components/Form"
import Footer from "./components/Footer"
export default function App() {
    return (
        <div>
            <Header />
            <Form />
            <Footer />
        </div>
    )
}
